import React, { Component, ReactNode } from 'react';
import { Typography, Grid, Button, Hidden } from '@material-ui/core'
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import { withRouter, RouteComponentProps } from 'react-router';
import { SimpleMessageQmoModal } from './QmoModal';
import UserMenu from './UserMenu';

const styles: { [name: string]: CSSProperties; } = {
    centered: {
        textAlign: 'center',
        cursor: 'pointer'
    }
}

type Props = {
    children?: ReactNode,
    showError?: boolean,
    errorMessage?: string,
    hideError?: () => void,
    isAuthenticated: boolean | null,
    isPublic: boolean,
    logout?: () => void,
    username?: string | null
} & RouteComponentProps<any>

class DefaultLayout extends Component<Props> {
    render() {
        return (
            <div className="layout">
                <Grid container style={{
                    paddingTop: '10px',
                    paddingBottom: '10px'
                }}>
                    <Hidden xsDown>
                        <Grid item sm={4}></Grid>
                    </Hidden>
                    <Grid item xs={12} sm={4}>
                        <Typography onClick={() => this.props.history.push("/")} style={styles.centered} variant="h3">QuoteMyOrder</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} style={{ textAlign: 'right' }}>
                        {this.props.isPublic === false && 
                            <UserMenu logout={this.props.logout!} username={this.props.username!} />
                        }
                    </Grid>
                </Grid>

                {this.props.children}

                {this.props.showError &&
                    <SimpleMessageQmoModal
                        open={this.props.showError || false}
                        title="There was a problem.."
                        message={() => <span>{this.props.errorMessage || ""}</span>}
                        customButtonsContent={() => {
                            return (
                                <Grid container>
                                    <Grid item xs={12} sm={12} style={{ textAlign: 'center' }}>
                                        <Button color="primary" variant="contained" onClick={this.props.hideError}>OK</Button>
                                    </Grid>
                                </Grid>
                            )
                        }}>
                    </SimpleMessageQmoModal>
                }
            </div>
        );
    }
}

export default withRouter(DefaultLayout)